// extracted by mini-css-extract-plugin
module.exports = {"adFallback":"ad-fallback-module--adFallback--2mUcj","noBorder":"ad-fallback-module--noBorder--1EY42"};